var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-view',{attrs:{"styles":"flex"}},[_c('btn-widget',_vm._b({on:{"on_click":_vm.$_upload}},'btn-widget',_vm.btn_data,false)),_vm._v(" "),_c('input',{ref:"uploader",staticStyle:{"display":"none"},attrs:{"type":"file","multiple":_vm.multiple},on:{"change":_vm.$_exe_upload}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5683cd38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BTXUI/upload/upload-widget.vue
// module id = null
// module chunks = 